<script setup lang="ts">
import lodashPick from 'lodash-es/pick';

export interface StoryblokUiPageGridProps {
    blok: StoryblokUiPageGrid;
}

// PROPS
const { blok } = defineProps<StoryblokUiPageGridProps>();

// COMPOSABLES
const { classes: partialClasses } = useStoryblokComponentClass(() => lodashPick(blok, ['maxWidth']));
const classes = computed(() => {
    let additionalClasses = '';

    switch (blok.columns) {
        case '2':
            additionalClasses = 'sm:grid-cols-2 lg:grid-cols-2';
            break;
        case '4':
            additionalClasses = 'sm:grid-cols-2 lg:grid-cols-4';
            break;
    }

    return [additionalClasses, ...partialClasses.value];
});
</script>

<template>
    <UPageGrid v-editable="blok" :class="classes">
        <template v-if="blok.items?.length" #default>
            <StoryblokComponent v-for="i in blok.items" :key="i._uid" :blok="i" />
        </template>
    </UPageGrid>
</template>
